import React from 'react';
import { BaseSelect } from 'src/components/common';
import { PGoalsSelect } from 'src/components/common/selects/BaseSelect/BaseSelect';

const goalSelectOptions = [
  { value: 'Promote my product/service', label: 'Promote my product/service' },
  { value: 'Promote my company', label: 'Promote my company' },
  { value: 'Further my career', label: 'Further my career' },
  { value: 'Establish myself as a thought leader', label: 'Establish myself as a thought leader' },
  { value: 'Expand my audience', label: 'Expand my audience' },
  { value: 'I provide PR services', label: 'I provide PR services' },
  { value: 'Others', label: 'Others' },
];

export const GoalsSelect: React.FC<PGoalsSelect> = (props) => {
  return <BaseSelect options={goalSelectOptions} withoutSearch {...props} />;
};
